import { render, staticRenderFns } from "./xmyjx.vue?vue&type=template&id=38a916ca&scoped=true"
import script from "./xmyjx.vue?vue&type=script&lang=js"
export * from "./xmyjx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a916ca",
  null
  
)

export default component.exports